/**
 * @module EgainConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const EgainConstants
 */
const EgainConstants = keyMirror({
  GET_SAML_TOKEN: null,
  GET_SAML_TOKEN_SUCCESS: null,
});

export default EgainConstants;
